import { BrowserRouter, Route, Routes } from "react-router-dom";
import { ScrollToTop } from "./components/ScrollToTop";

import Index from "./pages/Index";
import Messages from "./pages/Messages";
import { NIP19Page } from "./pages/NIP19Page";
import NotFound from "./pages/NotFound";

export function AppRouter() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<Index />} />
        <Route path="/messages" element={<Messages />} />
        {/* Specific routes for NIP-19 identifiers */}
        <Route path="/npub1*" element={<NIP19Page />} />
        <Route path="/nprofile1*" element={<NIP19Page />} />
        <Route path="/note1*" element={<NIP19Page />} />
        <Route path="/nevent1*" element={<NIP19Page />} />
        <Route path="/naddr1*" element={<NIP19Page />} />
        {/* ADD ALL CUSTOM ROUTES ABOVE THE CATCH-ALL "*" ROUTE */}
        <Route path="*" element={<NotFound />} />
      </Routes>
    </BrowserRouter>
  );
}
export default AppRouter;